import {AuthService} from '../services/auth.service';
import {CommonService} from '../services/common.service';
import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material';
import {OptionsDialogComponent} from './options-dialog/options-dialog.component';
import {QuestionsDialogComponent} from './questions-dialog/questions-dialog.component';
import {Router} from '@angular/router';

import QuestionnaireConfig from '../table/configs/questionnaire.json';

@Component({
  templateUrl: './questionaires.component.html'
})
export class QuestionairesComponent implements OnInit {
  questionnaireConfig: any;
  basicDetailsConfig: any;
  showBasicInfo = false;
  user: any;

  constructor(private authService: AuthService,
              private commonService: CommonService,
              private matDialog: MatDialog,
              private router: Router) {
    this.questionnaireConfig = QuestionnaireConfig;
  }

  public async ngOnInit(): Promise<any> {
    await this.initUser();
    await this.initBasicInfo();
  }

  private async initBasicInfo() {
    this.basicDetailsConfig = {
      subtitle: [{
        title: 'Ενέργειες Ερωτηματολογίων',
        value: ''
      }],
      title: 'Ερωτηματολόγια'
    };

    await this.initializeActions();
  }

  private async initializeActions() {
    const toolTip = 'Η εντολή είναι ήδη ολοκληρωμένη';
    const actions = [];

    const action1 = {
      function: () => {
        this.createQuestionnaire();
      },
      showAction: true,
      title: 'Δημιουργία ερωτηματολογίου',
      icon: 'build_tools',
      color: '#013e81',
      tooltip: toolTip
    };

    const action2 = {
      function: () => {
        this.showQuestionsDialog();
      },
      showAction: true,
      title: 'Ερωτήσεις',
      icon: 'question_answer',
      color: '#013e81',
      tooltip: toolTip
    };

    const action3 = {
      function: () => {
        this.showOptionsDialog();
      },
      showAction: true,
      title: 'Επιλογές Ερωτήσεων',
      icon: 'question_answer',
      color: 'green',
      tooltip: toolTip
    };

    actions.push(action2);
    actions.push(action3);
    actions.push(action1);

    if (actions.length > 0) {
      this.basicDetailsConfig.actions = actions;
      this.basicDetailsConfig.showActions = await this.commonService.showActions(this.user);
    } else {
      this.basicDetailsConfig.showActions = false;
    }
    this.showBasicInfo = true;
  }

  private async initUser() {
    this.user = await this.authService.getUser();
    await this.initBasicInfo();
  }

  private async createQuestionnaire() {
    await this.router.navigate(['questionnaire-creator']);
  }

  private showQuestionsDialog() {
    this.matDialog.open(QuestionsDialogComponent, {
      width: '500px',
      height: '800px',
      data: {
        user: this.user
      }
    });
  }

  private showOptionsDialog() {
    this.matDialog.open(OptionsDialogComponent, {
      width: '500px',
      height: '800px',
      data: {
        user: this.user
      }
    });

  }
}
